'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _panelsUi = require('panels-ui');

var _browserVendorPrefix = require('browser-vendor-prefix');

var _style = require('../style');

var _reactRedux = require('react-redux');

var _getGroupId = require('./get-group-id');

var _getGroupId2 = _interopRequireDefault(_getGroupId);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsSponsor = require('../widgets/sponsor');

var _widgetsSponsor2 = _interopRequireDefault(_widgetsSponsor);

var TeamCard = function TeamCard(props) {
  var actionStyle = _extends({}, style.action.base);

  actionStyle.backgroundImage = 'url(' + props.team.images.card + ')';
  actionStyle.marginTop = props.i === 0 ? 75 : 3;

  return _react2['default'].createElement(
    _panelsUi.Action,
    { href: props.team.id + '/', style: actionStyle, activeStyle: style.action.active, hoverStyle: style.action.active },
    props.team.name
  );
};

exports.TeamCard = TeamCard;
var Group = function Group(props) {
  var contactStyle = _extends({}, style.action.base, {
    marginTop: 50
  });

  return _react2['default'].createElement(
    _panelsUi.Panel,
    { width: props.width, style: style.panel },
    _react2['default'].createElement(
      'h1',
      { style: style.title },
      _react2['default'].createElement(
        'span',
        null,
        props.club.name
      ),
      _react2['default'].createElement(
        'span',
        null,
        props.group.name
      )
    ),
    _react2['default'].createElement(_widgetsSponsor2['default'], _extends({}, props.sponsor, { colour: 'BLUE', style: style.sponsor })),
    props.group.teams.map(function (team, i) {
      return _react2['default'].createElement(TeamCard, { team: props.teamsById[team], i: i, key: i });
    })
  );
};

exports.Group = Group;
var style = {
  action: {
    active: {
      paddingLeft: 55
    },
    base: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.alignSelfStretch, {
      backgroundSize: 'cover',
      color: _style.BLUE,
      fontSize: 30,
      height: 150,
      paddingLeft: 35,
      paddingTop: 15,
      paddingBottom: 15,
      textShadow: '0 0 10px ' + _style.WHITE,
      textTransform: 'uppercase',
      transition: 'padding-left 0.25s linear'
    })
  },
  panel: {
    backgroundColor: _style.WHITE_TRANSPARENT_85,
    color: _style.BLUE,
    fontFamily: _style.FONT,
    fontWeight: _style.FONT_LIGHT,
    paddingBottom: 200
  },
  title: {
    fontSize: 20,
    fontWeight: _style.FONT_LIGHT,
    marginTop: 85,
    paddingLeft: 35,
    paddingRight: 35,
    textTransform: 'uppercase'
  },
  sponsor: {
    marginTop: 25,
    paddingLeft: 35,
    paddingRight: 35
  }
};

function mapStateToProps(state, props) {
  var group = state.tournaments.groupsById[_getGroupId2['default'](props.tournamentId, props.groupRef)];

  return {
    club: state.tournaments.clubsById[props.tournamentId],
    group: group,
    sponsor: state.tournaments.sponsorsById[group.sponsorId],
    teamsById: state.teams.byId
  };
}

exports['default'] = _reactRedux.connect(mapStateToProps)(Group);